import { render } from "./ConfirmDialog.vue?vue&type=template&id=67f9fa8d"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=67f9fa8d&lang=css"

import exportComponent from "/codebuild/output/src1508006177/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__